import script from "./UserPublications.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserPublications.vue?vue&type=script&setup=true&lang=ts"

import "./UserPublications.vue?vue&type=style&index=0&id=31a31db6&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31a31db6"]])

export default __exports__